import { FC } from 'react';

import { IconSvg } from '@/components';
import { useUiStoreSelector } from '@/data';
import { useIsServerSide, useProducts } from '@/hooks';
import { getCartItemsCount } from '@/utils';

import style from './shopping.module.scss';

const ShoppingHeader: FC = () => {
  const { products } = useProducts();
  const { isServerSide } = useIsServerSide();
  const { setState } = useUiStoreSelector([]);

  const counter = getCartItemsCount(products);
  const cartLabel =
    counter > 0
      ? `Open shopping cart with ${counter} ${counter === 1 ? 'item' : 'items'}`
      : 'Open shopping cart';

  return (
    <button
      aria-label={cartLabel}
      className={style.shopping__action}
      onClick={() => {
        setState({ is_cart_open: true });
      }}
      type="button"
    >
      <IconSvg decorative={false} name="shopping" title={cartLabel} />
      {!isServerSide && counter !== 0 && (
        <span aria-atomic="true" aria-live="polite" className={style.counter}>
          {counter}
        </span>
      )}
    </button>
  );
};

export default ShoppingHeader;
